import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

interface AssetNode {
  id: any;
  assetName: string;
  children?: AssetNode[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-user-asset',
  templateUrl: './user-asset.component.html',
  styleUrls: ['./user-asset.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})


export class UserAssetComponent implements OnInit {
  buttonColorName: any;
  updateData: any;
  userListDataForAsset: any;
  dropdownSettingsForBand: IDropdownSettings = {};
  dropdownSettingsForAsset: IDropdownSettings = {};
  dropdownSettingsForEmployee: IDropdownSettings = {};
  selectedEmployeeIdForReport: any;
  dropdownDataForAsset: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  oprationMethod: any;
  todayDate: any;
  datedisplay: any
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService, public dialog: MatDialog,
    private config: Config, private httpService: HttpService, private datePipe: DatePipe, public dialogRef: MatDialogRef<UserAssetComponent>) {
    console.log(data);

    this.todayDate = new Date().toISOString().split('T')[0];
    this.datedisplay = this.todayDate
    this.oprationMethod = data.operation
    this.year = data?.year;
    this.fiscalYear = data?.fiscal_year;
    this.updateData = data?.data;
    console.log("this.updateData", this.updateData);
    if (this.updateData != null) {


      // this.selectedEmployee = this.updateData.users.map((elm: any) => elm.userId);
      this.selectedAsset = this.updateData.users.map((elm: any) => elm.assetId);
      this.selectedAsset = this.selectedAsset[0];
      console.log(this.selectedAsset);


      this.onAssetChange(this.selectedAsset);



    }


  }
  assetOptions: string[] = [
    'ASSET_GIVEN',
    'ASSET_REPAIRED',
    'RECEIVED_AFTER_EXIT',
    'NOT_RECEIVED_AFTER_EXIT',
    'IN_PROGRESS',
    'OTHER_REASON'
  ];




  ngOnInit() {

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');

    this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getAllaseetListingData();
    this.assetAllocationData();


    // this.allAssets = this.userListDataForAsset.users.map((asset: { assetName: any; }) => asset.assetName);

    this.dropdownSettingsForBand = {
      singleSelection: false,
      idField: 'id',
      textField: 'band',
      disabledField: 'disabled',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };
    this.dropdownSettingsForAsset = {
      singleSelection: true,
      idField: 'assetId',
      textField: 'asset',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };
    this.dropdownSettingsForEmployee = {
      singleSelection: false, // or true if only one selection is allowed
      idField: 'userId',      // Key for unique IDs
      textField: 'employeName', // Key for displayed text
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      disabledField: 'disabled', // Field to determine if the option is disabled
      allowSearchFilter: true, // Enable search functionality
    };

    //   this.dropdownSettingsForEmployee = {
    //     singleSelection: false,
    //     idField: 'userId',
    //     textField: 'employeName',
    //     disabledField: 'disabled', // Field to determine if the option is disabled
    //     allowSearchFilter: true,
    //     enableCheckAll: false,
    //      itemsShowLimit: 3,  
    // };


  }
  selectedAsset: any;

  isDropdownDisabled(): boolean {
    return this.dropDownForEmployee.every(emp => emp.enableCheckAll);

  }



  selectedEmployee: any;
  selectedSubAsset: any;

  filteredEmployees: any[] = [];
  filteredAssets: any[] = [];
  selectedBand: any[] = [];
  // selectedAssets:any;
  getupdateBandData: any = [];
  //   // This function will be triggered when the asset (band) changes
  onAssetChange(event: any) {
    this.selectedBand = [];
    this.selectedAsset = event;
    console.log(event);

    this.httpService.callGetService(`${this.config.bandList}/${event}`)
      .subscribe((elm: any) => {
        // this.dropDownForband = elm.data;
        // if (this.updateData != null) {

        //   this.selectedBand = this.updateData.users.map((elm: any) => 
        //     elm.band,

        // );
        //   this.getAllEmployeeRecord();




        // }
        if (this.updateData != null) {
          console.log('Inside if block');
          this.getupdateBandData = this.updateData.users.map((elm: any) => elm.band);

          this.dropDownForband = elm.data.map((band: any, index: any) => ({
            id: index,
            band: band,
            disabled: this.getupdateBandData.includes(band),
          }));

          this.selectedBand = this.updateData.users.map((elm: any, index: any) => ({
            id: index,
            band: elm.band,
            disabled: this.getupdateBandData.includes(elm.band),
          }));
          this.getAllEmployeeRecord();
        } else {
          console.log('Inside else block');
          this.getupdateBandData = [];
          this.dropDownForEmployee = [];
          this.selectedEmployee = [];
          this.userListDataForAsset = [];
          console.log(this.getupdateBandData);

          if (this.getupdateBandData.length == 0) {
            this.dropDownForband = elm.data.map((band: any, index: any) => ({
              id: index,
              band: band,
              disabled: false, // Always enabled
            }));
          }
          // this.getAllEmployeeRecord();
        }


      })
  }

  //   // This function will be triggered when an employee is selected


  onBandChange(event: any) {
    console.log('Selected Bands:', this.selectedBand); // Log the selected values (array of bands)
    this.selectedBand = event.value;  // Store the selected bands in the array



  }


  onEmployeeChange() {
    console.log(this.selectedBand);

    this.userListDataForAsset.users = this.userListDataForAsset.users.filter((elm: any) => this.selectedBand.includes(elm.band))
    console.log(this.userListDataForAsset);



  }
  selectedAssets: any[] = [];

  allAssets: string[] = []; // Holds all asset names to handle "Select All"


  onSelectSingleSelectFilter: any;
  // // Event Handlers
  onSelectSingleSelectFilterReport(event: any) {

    this.onSelectSingleSelectFilter = event.band;
    this.deselectBand = false;
    console.log(this.onSelectSingleSelectFilter);

    this.getAllEmployeeRecord();
    this.groupEmployees(); // Ensure groupEmployees uses selectedAssets properly


    if (this.selectedEmployee != null) {
      this.allocateEmployees();
    }
    console.log(this.selectedEmployee);



  }

  deselectBand: boolean = false;
  onSelectSingleDelectFilterReport(event: any) {
    this.onSelectSingleSelectFilter = event.band;
    this.deselectBand = true;
    this.getAllEmployeeRecord();
    this.groupEmployees();

    if (this.selectedEmployee != null) {
      this.allocateEmployees();
    }
    console.log(this.selectedEmployee);
  }



  selectAllBand(event: any) {
    console.log('All items selected:', event);
    this.selectedBand = [...event]; // Assign all selected items to selectedAssets
    this.getAllEmployeeRecord();
    this.groupEmployees();

  }

  selectAllEmp(event: any) {
    console.log('All items selected:', event);
    this.selectedEmployee = [...event]; // Assign all selected items to selectedAssets
    console.log(this.selectedEmployee);

    this.groupEmployees();

    this.allocateEmployees();

  }
  onDeSelectAllEmpForReport(event: any) {
    console.log('All items deselected:', event);
    this.selectedEmployee = []; // Clear selectedAssets

    this.groupEmployees();
  }
  onDeSelectAllEmpFor(event: any) {
    console.log('Deselect All Event:', event);

    if (!event || (Array.isArray(event) && event.length === 0)) {
      // Clear all selected employees when deselect all is triggered
      this.selectedEmployee = [];
      console.log('All items deselected');
    } else {
      // Check if the userId already exists in the selectedEmployee array
      const isUserIdPresent = this.selectedEmployee.some(
        (user: any) => user.userId == event.userId
      );

      if (isUserIdPresent) {
        // If the userId does not exist, push the event to the array
        this.selectedEmployee.push(event);
       
        
        this.allocateEmployees();
      } else {
        // Remove the record matching the userId
        this.selectedEmployee = this.selectedEmployee.filter(
          (user: any) => user.userId !== event.userId
        );
        this.deleteByEmployee(event)
        console.log('Item deselected:', event);
      }

    }


    console.log('Updated Selected Employees:', this.selectedEmployee);

    this.groupEmployees(); // Perform additional logic if necessary
  }
  deleteByEmployee(event: any) {

    let findUserId: any = [];
    findUserId.push(event.userId);


    let findAssetId = this.userListDataForAsset.users.filter((elm: any) => findUserId.includes(elm.userId));
    let id = findAssetId.map((elm: any) => elm.id)
    this.httpService.callDeleteService(`${this.config.deleteAssetFromEmployee}/${id[0]}`)
      .subscribe((elm: any) => {
        console.log(elm);
        if (elm) {
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: elm.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
        }
        this.assetAllocationData();
      })
  }

  onDeSelectAllBand(event: any) {
    console.log('All items deselected:', event);

    this.selectedBand = [];
    this.selectedEmployee = [];
    this.groupEmployees();
  }
  nedisableempBandArray: any = [];
  disableEmployeeSelection(): any {
    console.log(this.updateData.users);

    // Assuming that selectedEmployee is an array of selected employee objects
    if (this.updateData.users != 0) {
      this.selectedEmployee = this.updateData.users.map((elm: any) => ({
        userId: elm.userId,           // Matches 'idField' for the dropdown
        employeName: elm.employeeName // Matches 'textField' for display
      }));
    }
  }
  disabledata: any = [];

  getAllEmployeeRecord() {
    console.log("getAllEmployeeRecord");
    console.log(this.onSelectSingleSelectFilter);

    const band = this.selectedBand.map((elm: any) => elm.band);
    const today = new Date().toISOString().split('T')[0];
    const year = this.year.split('-')[0];

    const formData = {
      companyId: this.loggedInUserCompanyID,
      bands: band,
      from: today,
      to: today,
      fromYear: year,
      toYear: year,
    };

    this.httpService.callPostService(`${this.config.getAllEmployeeListAgainstBand}`, formData)
      .subscribe((elm: any) => {


        if (elm.data && this.updateData == null && !this.deselectBand) {
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: elm.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe((result) => {

          });

        }
        this.dropDownForEmployee = elm.data.map((user: any) => ({
          userId: user.id,
          employeName: user.firstName + user.lastName,
          userBand: user.band,
          enableCheckAll: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          allowSearchFilter: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          disabled: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : false,
        }));

        console.log(this.dropDownForEmployee);

        this.selectedEmployee = elm.data.map((user: any) => ({
          userId: user.id,
          employeName: user.firstName + user.lastName,
          enableCheckAll: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          allowSearchFilter: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          disabled: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : false,
        }));

        let emptyEmployeeArray: any[] = [];
        console.log("Initial Empty Array:", emptyEmployeeArray);

        if (this.updateData != null) {
          emptyEmployeeArray = this.selectedEmployee || [];
          console.log("Temp Employee Array:", emptyEmployeeArray);

          if (emptyEmployeeArray.length > 0) {
            this.selectedEmployee = emptyEmployeeArray;
          } else {
            this.selectedEmployee = this.updateData.users.map((elm: any) => ({
              userId: elm.userId,
              employeName: elm.employeeName,
              enableCheckAll: this.onSelectSingleSelectFilter === elm.band ? false : true,
              allowSearchFilter: this.onSelectSingleSelectFilter === elm.band ? false : true,
              disabled: this.onSelectSingleSelectFilter === elm.band ? false : true,
            }));
          }

          this.disabledata = this.dropDownForEmployee.every(emp => emp.enableCheckAll);
          console.log(this.disabledata);
        }

        this.allocateEmployees();
      });
  }

  onAssetClick() {
    console.log('Assets dropdown clicked');
    // You can handle other logic when dropdown is clicked, if needed
  }

  allocateEmployees() {

    const assetnameData = this.originalAssets.filter((elm: any) => elm.assetId == this.selectedAsset);
    const notMatchID = assetnameData.map((elm: any) => elm.userId);
    const data = this.selectedEmployee.filter((elm: any) => !notMatchID.includes(elm.userId));
    const employeeID = data.map((elm: any) => elm.userId);
    let userId:any=[]
    employeeID.filter((elm: any) => {
      if (!userId.some((e: any) => e === elm)) {
        userId.push(elm);
      }
    });
    

    const formData = {

      "companyId": this.loggedInUserCompanyID,
      "assetAuthorityId": null,
      "assetId": this.selectedAsset,
      "employeeIds": userId,
      "dateOfAllocation": null,
      "currentAssetDescription": ''
    }

    this.httpService.callPostService(`${this.config.allocateEmployee}`, formData)
      .subscribe((elm: any) => {
        this.assetAllocationData();

      })
  }




  assetManagementHeader = [
    { label: 'Asset', isMandatory: true, sortingName: 'asset' },
    { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
    { label: 'Band', isMandatory: true, sortingName: 'band' },
    { label: 'Allocating Dept', isMandatory: true, sortingName: 'allocatingAuthorityDept' },
    { label: 'Authority Name', isMandatory: true, sortingName: 'allocatingAuthorityName' },
    { label: 'Date Of Allocation', isMandatory: true, sortingName: 'reimbursementType' },
    { label: 'Current Asset Description', isMandatory: true, sortingName: 'currentAssetDescription' },
    { label: 'HR ADMIN/Allocating Authority Comment', isMandatory: true, sortingName: 'reimbursementLimit' },
    { label: 'Authority Comment Date', isMandatory: true, sortingName: 'actualAmount' },


  ];





  AllAssetListingData: any[] = [];
  getAllaseetListingData() {
    this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((elm: any) => {
        this.AllAssetListingData = elm.data;
        console.log(elm);


      })

  }
  originalAssets: any[] = [];
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((elm: any) => {
        console.log(elm);

        this.originalAssets = elm.data;

        // this.groupAssetsByName();
        this.groupEmployees();
      })

  }
  assets: any = [];
  allUsers: any[] = [];

  // Group assets by asset name and merge users
  groupAssetsByName() {
    console.log(this.originalAssets);

    // Create a map to hold the grouped assets
    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.originalAssets) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          allocatingAuthorityName: asset.allocatingAuthorityName,
          allocatingAuthorityDept: asset.allocatingAuthorityDept
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          isExpand: false,
          users: [{
            employeeName: asset.employeeName,
            userId: asset.userId,
            employeeComment: asset.employeeComment,
            allocatingAuthorityName: asset.allocatingAuthorityName,
            allocatingAuthorityDept: asset.allocatingAuthorityDept
          }]
        });


      }
    }

    // Convert the map to an array
    this.assets = Array.from(assetMap.values());
    console.log(this.updateData);
  }
  dropDownForband: any[] = [];
  dropDownForEmployee: any[] = [];
  finalTableListData: any[] = [];
  groupEmployees() {
    // Initialize an empty array to hold all users
    this.allUsers = [];

    // Loop through the original assets and collect all user details
    for (const asset of this.originalAssets) {
      this.allUsers.push({
        id: asset.id,
        employeeName: asset.employeeName,
        employeeComment: asset.employeeComment,
        employeeAssetStatus:asset.employeeAssetStatus,
        allocatingAuthorityName: asset.authorityName,
        authorityDepartment: asset.authorityDepartment,
        employeeEmail: asset.employeeEmail,
        authorityEmail: asset.authorityEmail,
        assetName: asset.assetName,
        band: asset.band,
        userId: asset.userId,
        assetId: asset.assetId,
        dateOfAllocation: asset.dateOfAllocation,
        currentAssetDescription: asset.currentAssetDescription,
        authorityCommentDate: asset.authorityCommentDate,
        authorityDepartmentComment: asset.authorityDepartmentComment
      });
    }


    const specificAsset = this.assets.map((asset: any) => {
      return {
        assetName: asset.assetName,
        band: asset.band,

      };
    });

    const list = {
      assetData: specificAsset,
      users: this.allUsers
    }

    if (this.updateData != null) {

      if (this.oprationMethod === "Update") {
        const insertIndex = this.assetManagementHeader.findIndex(
          (item) => item.sortingName === "currentAssetDescription"
        );

        if (insertIndex !== -1) {
          // Check if the 'employeeComment' or similar headers already exist
          const alreadyAdded = this.assetManagementHeader.some(
            (item) => item.sortingName === "employeeAssetStatus"
          );

          // Add the new items only if they don't already exist
          if (!alreadyAdded) {
            this.assetManagementHeader.splice(insertIndex + 1, 0,
              { label: 'Employee Status', isMandatory: true, sortingName: 'employeeAssetStatus' },
              { label: 'Employee Comment', isMandatory: true, sortingName: 'employeeComment' },
              { label: 'Employee Comment Date', isMandatory: true, sortingName: 'employeeCommentDate' }
            );
          }
        }
      }


      this.userListDataForAsset = this.updateData
      this.dropdownDataForAsset = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
        assetId: user.assetId, // Use a unique identifier (index or user-specific field)
        asset: user.assetName, // Use assetName for the display text
        employeeName: user.employeeName,
        userId: user.userId
      }));
      // this.dropDownForEmployee = list?.users?.map((user: any) => ({
      //   userId: user.userId, // Use a unique identifier (index or user-specific field)
      //   employeName: user.employeeName, // Use assetName for the display text
      //   band: user.band
      // }));

      // this.dropDownForEmployee = this.dropDownForEmployee?.filter((elm: any) =>
      //   this.selectedBand?.includes(elm.band)
      // );
      const selectedEmployees = this.selectedEmployee?.map((elm: any) => elm?.userId);
      let updatetimeselectAnotherEmployee = list?.users?.filter((elm: any) => selectedEmployees?.includes(elm.userId));
      updatetimeselectAnotherEmployee = updatetimeselectAnotherEmployee.filter((elm: any) => elm.assetId == this.selectedAsset);
      console.log(updatetimeselectAnotherEmployee);
      if (updatetimeselectAnotherEmployee.length > 0) {
        this.userListDataForAsset = { users: updatetimeselectAnotherEmployee }
        console.log("dgfhdf");

      }



    } else {
      this.userListDataForAsset = list

      // this.dropdownDataForAsset = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
      //   assetId: user.assetId, // Use a unique identifier (index or user-specific field)
      //   asset: user.assetName, // Use assetName for the display text
      //   employeeName: user.employeeName,
      //   userId: user.userId
      // }));

      // this.dropDownForEmployee = this.userListDataForAsset?.users?.map((user: any) => ({
      //   userId: user.userId, // Use a unique identifier (index or user-specific field)
      //   employeName: user.employeeName, // Use assetName for the display text
      //   band: user.band,
      //   assetName: user.assetName,
      //   assetId: user.assetId
      // })).filter((elm: any) => elm.assetId == this.selectedAsset);






      // // Filter the dropDownForEmployee array based on the selectedBand
      // this.dropDownForEmployee = this.dropDownForEmployee?.filter((elm: any) =>
      //   this.selectedBand?.includes(elm.band)
      // );
      const selectedEmployees = this.selectedEmployee?.map((elm: any) => elm?.userId);
      this.finalTableListData = this.userListDataForAsset?.users?.filter((elm: any) => selectedEmployees?.includes(elm.userId));
      //  this.userListDataForAsset.users = this.finalTableListData;

      this.userListDataForAsset.users = this.finalTableListData.map((record: any) => ({
        ...record,
        dateOfAllocation: record.dateOfAllocation ? record.dateOfAllocation : this.datedisplay, // Add dateOfAllocation field
        authorityCommentDate: record.authorityCommentDate ? record.authorityCommentDate : this.datedisplay
      })).filter((elm: any) => elm.assetId == this.selectedAsset)


    }


  }


  updatedAssetData: Asset[] = [];

  // -----------------------------------------------updated data from the user list------------------------------------------
  updateAssetData(index: number) {
    // Gather the updated data from the user list
    const updatedUser = this.userListDataForAsset.users[index];
    //-------------------------------------- authorityCommentDate----------------------------------------------
    let selectedDate = new Date(updatedUser.authorityCommentDate);  // Set the date at midnight
    let localDate = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
    const authorityCommentDate = localDate.toISOString();

    //-----------------------------------------dateOfAllocation---------------------------------------

    let selecteddateOfAllocation = new Date(updatedUser.dateOfAllocation);  // Set the date at midnight
    let date = new Date(selecteddateOfAllocation.getTime() - selecteddateOfAllocation.getTimezoneOffset() * 60000);
    const dateOfAllocation = date.toISOString();


    const existingIndex = this.updatedAssetData.findIndex(
      data => data.assetName === updatedUser.assetName && data.id === updatedUser.id
    );

    if (existingIndex === -1) {
      // If not found, add a new object with updated data
      this.updatedAssetData.push({
        id: updatedUser.id,
        assetName: updatedUser.assetName,
        currentAssetDescription: updatedUser.currentAssetDescription,
        authorityDepartmentComment: updatedUser.authorityDepartmentComment,
        authorityCommentDate: authorityCommentDate, // Corrected property name
        dateOfAllocation: dateOfAllocation
      });
    } else {
      // If found, update the existing object
      this.updatedAssetData[existingIndex] = {
        id: updatedUser.id,
        assetName: updatedUser.assetName,
        currentAssetDescription: updatedUser.currentAssetDescription,
        authorityDepartmentComment: updatedUser.authorityDepartmentComment,
        authorityCommentDate: authorityCommentDate,
        dateOfAllocation: dateOfAllocation
      };
    }

  }
  updateDataByHr() {

    this.updatedAssetData.forEach((element: any) => {
      this.httpService.callPutService(`${this.config.updateByHR}`, element).subscribe((result: any) => {
        console.log(result);
        // this.assetAllocationData();
        // this.dialogRef.close();
        if (result) {

          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: result.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe((result) => {

            this.dialogRef.close();
          });
        }

      })
    })

  }
  cancelData() {
    this.dialogRef.close();
  }
}

interface Asset {
  assetName: string;
  id: any

  currentAssetDescription: string;
  authorityDepartmentComment: string;
  dateOfAllocation: string,
  authorityCommentDate: string;  // Changed from dateOfAllocation to authorityCommentDate
}
